import { motion } from 'framer-motion';
import V5_1 from '../../assets/images/home/vector5/vector5-1.svg';
import V5_2 from '../../assets/images/home/vector5/vector5-2.svg';
import V5_3 from '../../assets/images/home/vector5/vector5-3.svg';
import V5_4 from '../../assets/images/home/vector5/vector5-4.svg';
import V5_5 from '../../assets/images/home/vector5/vector5-5.svg';
import V5_6 from '../../assets/images/home/vector5/vector5-6.svg';
import V5_7 from '../../assets/images/home/vector5/vector5-7.svg';

const Vector5 = () => {
  return (
    <motion.div className="vector" id="vector5"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.9 }}
    >
      <img src={V5_1} alt="Décoration à droite" />
      <img src={V5_2} alt="Décoration à droite" />
      <img src={V5_3} alt="Décoration à droite" />
      <img src={V5_4} alt="Décoration à droite" />
      <img src={V5_5} alt="Décoration à droite" />
      <img src={V5_6} alt="Décoration à droite" />
      <img src={V5_7} alt="Décoration à droite" />
    </motion.div>
  );
};

export default Vector5;